import React from 'react';
import { connect } from 'react-redux';

import { getUserProfile } from '@topconagriculture/profiling';

import { RootState } from '../store/reducers';
import { UserPersonas } from '../store/user/user.types';

function withUserPersonas(Comp: React.FunctionComponent<{ children?: React.ReactNode }>) {
  class WrappedComponent extends React.Component {
    public render() {
      return <Comp {...this.props} />;
    }
  }

  const mapStateToProps = (state: RootState, props) => ({
    ...props,
    userPersonas: getUserProfile(state),
  });

  return connect(mapStateToProps)(WrappedComponent);
}

export interface WithUserPersonas {
  userPersonas: UserPersonas;
}

export default withUserPersonas;
